import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pushApi } from '../api/push-api';

import { pushKeys } from './push-keys';

/** The card shows how many devices the push services accepted. */
export function useSendTestPush() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: pushApi.test,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pushKeys.settings() }),
  });
}
